/** Phase 19 */
import { getAggregateReports } from '../infrastructure/storage/domainAggregateStore';
import { getEntityReports } from '../infrastructure/storage/entityAggregateStore';
import { createRootDocumentEntityReadSource } from './rootDocumentEntityReadSourceFactory';

const source = createRootDocumentEntityReadSource({
  field: 'reports',
  getEntity: getEntityReports,
  getAggregate: getAggregateReports,
  emptyValue: {}
});

export const readReportsFromMergedBlob = source.readFromMergedBlob;
export const readReportsFromBestSource = source.readFromBestSource;
export const refreshReportsReadCache = source.refreshReadCache;
export const getCachedReportsRead = source.getCachedRead;
export const clearReportsReadCache = source.clearReadCache;
export const readReportsSyncForBusiness = source.readSyncForBusiness;
